<template>
    <div class="modal hide fade in" id="modalEnvio" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{this.Titulo}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
                <div class="row" v-if="Incidente!=null" >  
                    <div class="form-group col-12" id="Contenedor_div"> 
                        <label>Contenedor</label>
                        <input type="text" class="form-control" v-model="Incidente.Contenedor" />
                    </div>
                </div>
                <div class="row" v-if="Terceria!=null" >  
                    <div class="form-group col-12" id="Contenedor_div"> 
                        <label>Contenedor</label>
                        <input type="text" class="form-control" v-model="Terceria.Contenedor" />
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12" id="BusquedaArea_div"> 
                        <label>Ubicación</label>                                  
                        <CAreas
                            v-on:valorParaElPadre="cambioDeArea" 
                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                :idDelInput="'catalogoAreas'" 
                                :parametros="parametros_Area.parametros" 
                                :valorDefinido="parametros_Area.areaId"
                                :key="parametros_Area.areaId"
                            >
                        </CAreas>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12" id="BusquedaEstatus_div"> 
                        <label v-if="Incidente!=null">Estatus del Incidente:</label>
                        <label v-if="Terceria!=null">Estatus de la Tercería:</label>
                            <Estatus 
                                v-on:valorParaElPadre="cambioDeEstatus" 
                                :prefijo ="enumeraciones.etiquetasDeHTML.Select"
                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                :idDelInput="'catalogoEstatus'"
                                :parametros ="parametros_TipoEstatus"
                                :valorDefinido="parametros_TipoEstatus.tipoEstatusVolumenId"
                                :key="parametros_TipoEstatus.tipoEstatusVolumenId"
                            >
                            </Estatus>
                    </div>
                </div>
                    
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" id="botonCancelar" >Cancelar</button>
          <button type="button" class="btn btn-dark" id="botonAceptar" >Aceptar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'

export default {
    components:{
            Estatus : catalogos.ArchivoJudicial.C004TipoEstatusVolumen,
            CAreas : catalogos.ArchivoJudicial.C001Areas
        },
    props : {
        Incidente : Object,
        usrArchivo: Object,
        Terceria: Object
    },
    data(){
        return{
            enumeraciones,
            parametros_TipoEstatus: {
                tipoEstatusVolumenId: -1,
                },
            parametros_Area: {
                areaId: -1,
                parametros : {conMaterias: true,
                conOrdenamientoPorSistema:true}
                //Materias: [ { MateriaId: 1, Activo: true },{ MateriaId: 2, Activo: true }, { MateriaId: 3, Activo: true }, { MateriaId: 4, Activo: true }, { MateriaId: 5, Activo: true } , { MateriaId: 6, Activo: true }, { MateriaId: 9, Activo: true }, { MateriaId: 13, Activo: true } ], 
                },
            UbicacionEstatus: {
                areaId: 0,
                tipoEstatusVolumenId: 0
            },
            Titulo: ""
        }
    },
    methods:{
        Mostrar: function () {
            $('#modalEnvio').modal('show');
            $('#botonCancelar').unbind('click').click(this.Cerrar);
            $('#closeModal').unbind('click').click(this.Cerrar);
            $('#botonAceptar').unbind('click').click(this.Edicion);
            },
        ModalClose: function(b1, b2, incidente){
            $('#modalEnvio').modal('hide');
            //$('#modalSolicitud').modal('dispose');
            this.$emit('dialogo', {"Estatus": b1, "Actualizacion": b2, "Incidente": incidente});
        },
        Cerrar(){
            this.ModalClose(false, false)
        },
        cambioDeEstatus(datos){
            this.parametros_TipoEstatus.tipoEstatusVolumenId = parseInt(datos.target.value);

        },
        cambioDeArea(datos){
            this.parametros_Area.areaId = parseInt(datos[0].target.value);
            
            if(this.parametros_Area.areaId == 21)
            {
                this.parametros_TipoEstatus.tipoEstatusVolumenId =1;
            }
            else{
                this.parametros_TipoEstatus.tipoEstatusVolumenId =3;
            }
        },
        Edicion(){
            var MovimientoDocumentos ={};
            if(this.UbicacionEstatus.areaId != this.parametros_Area.areaId && this.UbicacionEstatus.tipoEstatusVolumenId!=this.parametros_TipoEstatus.tipoEstatusVolumenId)
            {
                MovimientoDocumentos =
                    {
                        "AreaQuePresta": {"AreaId": this.UbicacionEstatus.areaId },
                        "AreaQueRecibe": {"AreaId": this.parametros_Area.areaId },
                        "IncidenteId": this.Incidente!=null ? this.Incidente.IncidenteId: null,
                        "TerceriaId": this.Terceria!=null? this.Terceria.TerceriaId: null,
                        "Observaciones": "Movimiento generado por correción de ubicación del documento",
                        "TiposMovimientos": {"TipoMovimientoId": this.parametros_TipoEstatus.tipoEstatusVolumenId},
                        "UsuarioQuienPresta": {"IdUsuario": this.UbicacionEstatus.areaId!=21 ? 6 : this.usrArchivo.IdUsuario},
                        "UsuarioQuienRecibe": {"IdUsuario": this.parametros_Area.areaId!=21 ? 6 : this.usrArchivo.IdUsuario},
                        "UsuarioQuienRegistra": {"IdUsuario": this.usrArchivo.IdUsuario },
                        "VolumenId": null,
                    }
                
            }
            
            var peticion= { 
                "Incidentes":{
                    "IncidenteId": this.Incidente!=null ? this.Incidente.IncidenteId : null,
                    "Contenedor": this.Incidente !=null ? this.Incidente.Contenedor: null,
                    "Area": this.Incidente!=null ? this.parametros_Area: null,
                    "EstatusVolumenes": this.Incidente != null? this.parametros_TipoEstatus: null
                     },
                "Tercerias": {
                    "TerceriaId": this.Terceria!=null ? this.Terceria.TerceriaId : null,
                    "Contenedor": this.Terceria !=null ? this.Terceria.Contenedor: null,
                    "Area": this.Terceria!=null ? this.parametros_Area: null,
                    "EstatusVolumenes": this.Terceria != null? this.parametros_TipoEstatus: null
                },
                MovimientoDocumentos
                };
                    comun.SeEstaCargandoInformacion(true);
                    axios.post(api.conexion + api.ArchivoJudicial.GuardarIncidente, peticion,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                    .then(respuesta => {
                      if (respuesta.data.SiHayError){
                            console.log(respuesta);
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                            comun.SeEstaCargandoInformacion(false);
                        }
                        else{
                            var mensaje="";
                            if(this.Incidente!=null)
                            {
                                mensaje= "Se Modifico satisfactoriamente el Incidente"
                            }
                            else
                            {
                                mensaje="Se Modifico satisfactoriamente el Incidente"
                            }
                            comun.mensajeDeAlerta(mensaje, null, null);
                            comun.SeEstaCargandoInformacion(false);
                            this.ModalClose(false, true)
                        }
                        
                    })
                    .catch(e=> {
                        console.log("No Hay Respuesta del Servidor" + e);
                        comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
                        });
        }
    },
    mounted() {
        if(this.Incidente!=null)
        {
            this.UbicacionEstatus.areaId = this.Incidente.Area.AreaId;
            this.UbicacionEstatus.tipoEstatusVolumenId = this.Incidente.EstatusVolumenes.TipoEstatusVolumenId;
            this.parametros_Area.areaId = this.Incidente.Area.AreaId;
            this.parametros_TipoEstatus.tipoEstatusVolumenId = this.Incidente.EstatusVolumenes.TipoEstatusVolumenId;
            this.Titulo= "Edición de Incidente";
        };
        if(this.Terceria!=null)
        {
            this.UbicacionEstatus.areaId = this.Terceria.Area.AreaId;
            this.UbicacionEstatus.tipoEstatusVolumenId = this.Terceria.EstatusVolumenes.TipoEstatusVolumenId;
            this.parametros_Area.areaId = this.Terceria.Area.AreaId;
            this.parametros_TipoEstatus.tipoEstatusVolumenId = this.Terceria.EstatusVolumenes.TipoEstatusVolumenId;
            this.Titulo= "Edición de Terceria";
        }
        
        this.Mostrar();

    }
}


</script>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/EditaIncidente.vue